export default function Drive() {
    return <h2>Google Drive</h2>;
}